// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-text-new {
    text-align: left !important;
    margin-top: 40px;
}

.term-new-item-excel table {
    width: 100%;
    border: 1px solid #000000;
    border-collapse: collapse;
    margin: 20px 0;
}

.term-new-item-excel thead tr {
    background: #d0d0d0
}

.term-new-item-excel th {
    text-align: center;
    font-weight: 600;
    color: #000;
    border: 1px solid #000000;
}

.term-new-item-excel tbody tr {
    border: 1px solid #000000;
}

.term-new-item-excel tbody tr:last-child {
    border-bottom: none;
}

.term-new-item-excel td {
    border: 1px solid #000000;
    padding: 18px 25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/protection/index.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":[".footer-text-new {\n    text-align: left !important;\n    margin-top: 40px;\n}\n\n.term-new-item-excel table {\n    width: 100%;\n    border: 1px solid #000000;\n    border-collapse: collapse;\n    margin: 20px 0;\n}\n\n.term-new-item-excel thead tr {\n    background: #d0d0d0\n}\n\n.term-new-item-excel th {\n    text-align: center;\n    font-weight: 600;\n    color: #000;\n    border: 1px solid #000000;\n}\n\n.term-new-item-excel tbody tr {\n    border: 1px solid #000000;\n}\n\n.term-new-item-excel tbody tr:last-child {\n    border-bottom: none;\n}\n\n.term-new-item-excel td {\n    border: 1px solid #000000;\n    padding: 18px 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
